<text-box #inputQuery
          [view]="view"
          [immediate]="true"
          (onEnterKey)="debounceEnd(inputQuery.value)"
          (onValueChange)="debounceStart(inputQuery.value)">
</text-box>
